import { Sparkles, Ruler, AlertTriangle } from "lucide-react";
import { Prio } from "@/components/StatusBadge";

const ObjectRow = ({ o, i }) => (
  <div className="border border-slate-800 rounded-md p-3 bg-slate-950/50" data-testid={`ai-object-${i}`}>
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <span className="font-mono text-[10px] bg-red-500 px-1.5 rounded-sm">{o.regio}</span>
        <span className="font-display font-semibold capitalize text-base">{o.type}</span>
        {!o.is_bouwwerk && <span className="text-[10px] text-slate-500 font-mono">GEEN BOUWWERK</span>}
      </div>
      <span className="font-mono text-xs text-slate-400">{Math.round((o.zekerheid || 0) * 100)}%</span>
    </div>
    <div className="flex items-center gap-1.5 mt-2 font-mono text-xs text-amber-300">
      <Ruler className="h-3.5 w-3.5" /> ca. {o.lengte_m} × {o.breedte_m} m · {o.oppervlakte_m2} m²
    </div>
    {o.toelichting && <p className="text-xs text-slate-400 mt-2 leading-relaxed">{o.toelichting}</p>}
    {o.vergunning_match && (
      <div className={`mt-2 text-[11px] rounded border px-2 py-1.5 ${o.vergunning_niveau === "zeker" ? "border-lime-500/40 bg-lime-500/10 text-lime-300" : "border-amber-500/30 bg-amber-500/5 text-amber-300"}`} data-testid={`ai-object-permit-${i}`}>
        <span className="font-mono uppercase tracking-wider">{o.vergunning_niveau === "zeker" ? "Vergund" : "Mogelijk vergund"}</span> · {o.vergunning_match.bron}{o.vergunning_match.datum && ` · ${o.vergunning_match.datum}`}
        <div className="text-slate-300 mt-0.5">{o.vergunning_match.url ? <a href={o.vergunning_match.url} target="_blank" rel="noreferrer" className="underline">{o.vergunning_match.titel}</a> : o.vergunning_match.titel}</div>
      </div>
    )}
    {o.vergunning_niveau === null && o.is_bouwwerk && <p className="text-[11px] text-rose-400 mt-1">Geen passende vergunning gevonden</p>}
    {o.pand_overlap > 0.3 && <p className="text-[11px] text-sky-400 mt-1">Overlapt {Math.round(o.pand_overlap * 100)}% met geregistreerd BAG-pand</p>}
  </div>
);

export const AiAssessment = ({ samenvatting, objecten = [], advies, prioriteit, aiError }) => (
  <div className="space-y-3" data-testid="ai-assessment">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2 font-mono text-[11px] tracking-widest text-blue-400 uppercase"><Sparkles className="h-3.5 w-3.5" /> AI-suggestie</div>
      <Prio value={prioriteit} />
    </div>
    <p className="text-sm leading-relaxed" data-testid="ai-summary">{samenvatting}</p>
    {advies && <div className="text-xs text-slate-400">Advies: <span className="text-white font-medium uppercase font-mono">{advies.replace("_", " ")}</span></div>}
    {aiError && <div className="flex gap-2 text-xs text-amber-400"><AlertTriangle className="h-4 w-4 shrink-0" />AI niet beschikbaar: {aiError}</div>}
    {objecten.map((o, i) => <ObjectRow key={i} o={o} i={i} />)}
  </div>
);
